import Dashboard from "../../common/components/layout/Dashboard";
import Toast from "../../common/components/ui/toast";
import { ToastProvider } from "../../common/components/ui/toast/toast.provider";
import TableTicketStock from "./components/tables/tableTicketStock";

function TicketStockRegisterPage() {
  return (
    <ToastProvider>
      <Dashboard>
        <TableTicketStock />
      </Dashboard>
      <Toast />
    </ToastProvider>
  )
}

export default TicketStockRegisterPage;